import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import axioPath from '../../../../../api/axioPath';
import { SearchWrapper } from '../../Admin/DashBoard/dashBoardStyled'
import TooltipMaterial from "@material-ui/core/Tooltip";
import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../components/Spinner'
import CommentBoxModal from "web/components/CommentBoxModal";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { addminSubscriptionList } from '../../../../../redux/actions/admin';

import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import CsvDownloader from 'react-csv-downloader';
import { stateConvert } from 'web/components/utils/stateAbbreviation';

function Subscription() {
    const dispatch = useDispatch();
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const token = localStorage.getItem("token");
    const [modal, setModal] = useState(false);
    const [getIndex, setIndex] = useState();
    const [modalMessage, setModalMessaage] = useState('')
    const [basicModal, setBasicModal] = useState(false);
    const [basicModalMessage, setBasicModalMessaage] = useState('')
    const [tableSearch, setTableSearch] = useState('')
    const [addAomment, setComment] = useState();
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const adminRoles = useSelector(state => state.admin.adminRoles)

    const [commentModal, setCommentModal] = useState(false)
    const commentToggleModal = () => setCommentModal(!commentModal)
    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        fetchMyAPI();
    }, []);

    const fetchMyAPI = async () => {
        let response = '';
        response = await dispatch(addminSubscriptionList());
        if (response.status === 'SUCCESS') {
            if (response.payload.length !== 0) {
                let adminSubscriptionDataList = response.payload
                let pageData = JSON.parse(JSON.stringify(adminSubscriptionDataList.reverse()))
                setDataList(adminSubscriptionDataList)
                //set csv data
                setCSVDate(adminSubscriptionDataList)
                setFinalData(pageData.splice(page * 10 - 10, 10))
                if (adminSubscriptionDataList.length % 10 === 0) {
                    setPageCount(adminSubscriptionDataList.length / 10)
                } else {
                    setPageCount(Math.trunc(adminSubscriptionDataList.length / 10) + 1)
                }
                setTableSearch('')
            }
        } else {
            if (response.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setBasicModalMessaage(response.message)
                setBasicModal(!modal)
            }
        }
    };

    const handleChange = (event, value) => {
        setPage(value);
        const search = tableSearch
        let dataListtemp = dataList.filter(value => {
            return (
                (value.locationName !== null && value.locationName.toString().toLowerCase().includes(search.toLowerCase())) ||
                value.city?.toString().toLowerCase().includes(search.toLowerCase()) ||
                stateConvert(value.state)?.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.zip?.toString().toLowerCase().includes(search.toLowerCase()) ||
                (value.currentPeriodStart !== null && value.currentPeriodStart.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.currentPeriodEnd !== null && value.currentPeriodEnd.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.amount !== null && (value.amount / 100)?.toString()?.includes(search.toString())) ||
                (value.subscriptionStatusDetails !== null && value.subscriptionStatusDetails?.subscriptionStatus.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        // let dataListtemp = dataList.filter(value => {
        //     return (
        //         (value.locationName !== null && value.locationName.toString().toLowerCase().includes(search.toLowerCase())) ||
        //         (value.currentPeriodStart !== null && value.currentPeriodStart.toString().toLowerCase().includes(search.toLowerCase())) ||
        //         (value.currentPeriodEnd !== null && value.currentPeriodEnd.toString().toLowerCase().includes(search.toLowerCase())) ||
        //         (value.amount !== null && (value.amount / 100)?.toString()?.includes(search.toString())) ||
        //         (value.subscriptionStatusDetails !== null && value.subscriptionStatusDetails.subscriptionStatus.toString().toLowerCase().includes(search.toLowerCase()))
        //     )
        // }
        // );

        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                (value.locationName !== null && value.locationName.toString().toLowerCase().includes(search.toLowerCase())) ||
                value.city?.toString().toLowerCase().includes(search.toLowerCase()) ||
                stateConvert(value.state)?.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.zip?.toString().toLowerCase().includes(search.toLowerCase()) ||
                (value.currentPeriodStart !== null && value.currentPeriodStart.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.currentPeriodEnd !== null && value.currentPeriodEnd.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.amount !== null && (value.amount / 100)?.toString()?.includes(search.toString())) ||
                (value?.subscriptionStatusDetails !== null && value?.subscriptionStatusDetails?.subscriptionStatus.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setPage(1)
        setCSVDate(dataListtemp)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        setFinalData(dataListtemp.splice(0, 10))
    }

    const cancelSubscription = (e, index) => {
        setIndex(index)
        commentToggleModal()

        // e.preventDefault()
        // axioPath.post(`/user/subscription/cancel?subscriptionId=${finalData[index].subscriptionId}`)
        //     .then((response) => {
        //         setModal(!modal)
        //         setModalMessaage(response.data.message)
        //     }).catch((ex) => {
        //     });
    }

    const handleToggle = () => {
        setModal(!modal);
        fetchMyAPI();
    }
    // table header
    let headerArr = [
        { title: 'Company/Location Name', },
        { title: 'City', },
        { title: 'State', },
        { title: 'Zip', },
        { title: 'Broker', },
        { title: 'FC Member', },
        { title: 'Subscription Created Date', },
        { title: 'Valid Till', },
        { title: 'Subscription Amount', },
        { title: 'Last Amount Paid On', },
        { title: 'Status', },
        { title: 'Action', },
        { title: 'Comment', }
    ];

    //for csv download
    const columns = [
        { id: 'CompanyName', displayName: 'Company/Location Name' },
        { id: 'City', displayName: 'City' },
        { id: 'State', displayName: 'State' },
        { id: 'Zip', displayName: 'Zip' },
        { id: 'Broker', displayName: 'Broker' },
        { id: 'FCMember', displayName: 'FC Member' },
        { id: 'SubscriptionDate', displayName: 'Subscription Created Date' },
        { id: 'ValidTill', displayName: 'Valid Till' },
        { id: 'AmountPaid', displayName: 'Amount Paid' },
        { id: 'LastPaid', displayName: 'Last Amount Paid On' },
        { id: 'Status', displayName: 'Status' },
        { id: 'Comment', displayName: 'Comment' },
    ]

    const setCSVDate = (resultData) => {
        let tempCsvData = resultData.map(items => {
            let userTypeTemp
            if (items.buyer) userTypeTemp = 'Buyer'
            if (items.seller) userTypeTemp = 'Seller'
            if (items.buyer && items.seller) userTypeTemp = 'Both'

            const formattedZip = items.zip ? items.zip.toString().padStart(5, '0') : "";

            return ({
                CompanyName: items.locationName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                City: items.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                State: stateConvert(items.state),
                // Zip: items.zip,
                Zip: formattedZip,
                Broker: items.isReselling ? 'Yes' : 'No',
                FCMember: items.innerCircle ? 'Yes' : 'No',
                SubscriptionDate: items.created ? moment(items.created).format("MM-DD-YYYY") : '',
                ValidTill: items.currentPeriodEnd ? moment(items.currentPeriodEnd).format("MM-DD-YYYY") : '',
                AmountPaid: `$ ${(items.amount) / 100}`,
                LastPaid: items.currentPeriodStart ? moment(items.currentPeriodStart).format("MM-DD-YYYY") : '',
                Status: items?.subscriptionStatusDetails?.subscriptionStatus === 'TRAIL' ? 'TRIAL' :
                    items?.subscriptionStatusDetails?.subscriptionStatus === 'CANCELLED_AT_THE_PERIOD_END' ? 'Cancel at end of billing cycle' : items?.subscriptionStatusDetails?.subscriptionStatus,
                Comment: items?.comment,
            })
        })
        setCsvData(tempCsvData)
    }

    const buttonStyle = { background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }
    const disabledButtonStyle = { background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', opacity: '0.5' }

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('SUBSCRIPTION_ADMIN'))) ?
                <TableWrapper>
                    {loaderVisible && <Spinner />}
                    <Heading>
                        <h3>SUBSCRIPTION</h3>
                        <div className='d-flex flex-wrap flex-sm-nowrap'>
                            <SearchWrapper>
                                <input type="text" placeholder='Search' value={tableSearch}
                                    onChange={handleSearchChange} />
                                <AiOutlineSearch />
                            </SearchWrapper>
                            <CsvDownloader
                                filename="User Subscription Report"
                                columns={columns}
                                datas={csvData}>
                                <button
                                    style={buttonStyle}>
                                    Export
                                </button>
                            </CsvDownloader>
                        </div>
                    </Heading>

                    <Table responsive>
                        <thead>
                            <tr>
                                {headerArr.map((items, index) => (
                                    <th key={index}>{items.title}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                finalData.map((items, index) => (
                                    <tr key={index}>
                                        <td>{items.locationName}</td>
                                        <td>{items.city?.trim()}</td>
                                        <td>{stateConvert(items.state)}</td>
                                        <td>{items.zip}</td>
                                        <td>{items.isReselling ? 'Yes' : 'No'}</td>
                                        <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                                        <td>{items.created !== null ? moment(items.created).format("MM/DD/YYYY") : ''}</td>
                                        <td>{items.currentPeriodEnd !== null ? moment(items.currentPeriodEnd).format("MM/DD/YYYY") : ''}</td>
                                        <td>{`$ ${((items.amount) / 100)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}</td>
                                        <td>{items.currentPeriodStart !== null ? moment(items.currentPeriodStart).format("MM/DD/YYYY") : ''}</td>
                                        <td style={{textWrap : 'nowrap'}}>{items?.subscriptionStatusDetails !== null && items?.subscriptionStatusDetails?.subscriptionStatus === 'TRAIL' ? 'TRIAL' :
                                            items?.subscriptionStatusDetails?.subscriptionStatus === 'CANCELLED_AT_THE_PERIOD_END' ? 'Cancel at end of billing cycle' : items?.subscriptionStatusDetails?.subscriptionStatus}</td>
                                        <td>
                                            <button
                                                disabled={items?.subscriptionStatusDetails !== null && (items?.subscriptionStatusDetails?.subscriptionStatus === 'CANCELLED' || items?.subscriptionStatusDetails?.subscriptionStatus === "CANCELLED_AT_THE_PERIOD_END") ? true : false}
                                                onClick={e => {
                                                    cancelSubscription(e, index)
                                                }}
                                                style={items?.subscriptionStatusDetails !== null && (items?.subscriptionStatusDetails?.subscriptionStatus === 'CANCELLED' || items?.subscriptionStatusDetails?.subscriptionStatus === "CANCELLED_AT_THE_PERIOD_END") ? disabledButtonStyle : buttonStyle}>
                                                CANCEL SUBSCRIPTION
                                            </button>
                                        </td>
                                        <td>
                                            {items?.comment && <TooltipMaterial
                                                placement="top"
                                                arrow
                                                title={items?.comment}
                                                enterTouchDelay={0}
                                            >
                                                <span className={"remark"}>{items?.comment}</span>
                                            </TooltipMaterial>}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>

                    {dataList.length !== 0 && <Pagination count={pageCount}
                        page={page}
                        onChange={handleChange} />}

                    <Modal isOpen={modal}>
                        <ModalHeader toggle={handleToggle}>Subscription Status</ModalHeader>
                        <ModalBody>
                            {modalMessage}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleToggle}>OK</Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={basicModal} centered={true}>
                        <ModalBody style={{ textAlign: 'center' }}>
                            {basicModalMessage}
                        </ModalBody>
                        <ModalFooter style={{ justifyContent: 'center' }}>
                            <Button color="primary" onClick={handleToggle}>OK</Button>
                        </ModalFooter>
                    </Modal>
                </TableWrapper>
                :
                <p>You are not authorized to view this page.</p>
            }

            <CommentBoxModal
                isOpen={commentModal}
                toggle={commentToggleModal}
                title=""
                content="Are you sure you want to cancel this subcription?"
                onClickHander={(val) => {
                    if (val === "no") {
                    }
                    else {
                        if (val) {
                            let data = {
                                subscriptionId: finalData[getIndex].subscriptionId,
                                comment: val
                            }
                            axioPath.post(`/user/subscription/cancel?subscriptionId=${finalData[getIndex].subscriptionId}&comment=${val}`, {}, {
                                headers: {
                                  Authorization: `${token}`,
                                },
                              })
                                .then((response) => {
                                    if (response.data?.message === "Full authentication is required to access this resource") {
                                        history.push('/sign-in');
                                    } else {
                                        setModal(!modal)
                                        setModalMessaage(response.data.message)
                                    }
                                }).catch((ex) => {
                                    setModalMessaage(ex.message)
                                    setModal(!modal)
                                });

                            // const token = localStorage.getItem("token")
                            // axioPath.post('/user/subscription/cancel', data, {
                            //     headers: {
                            //         Authorization: `${token}`,
                            //     },
                            // }).then((response) => {
                            //     if (response.data?.message === "Full authentication is required to access this resource") {
                            //         history.push('/sign-in');
                            //     } else {
                            //         setModal(!modal)
                            //         setModalMessaage(response.data.message)
                            //     }
                            // }).catch((ex) => {
                            //     setModalMessaage(ex.message)
                            //     setModal(!modal)
                            // });
                        }

                    }
                }}
                link="/"
            />
        </>
    )

}

export default Subscription